import { observable, action } from 'mobx';

export interface DebugLogEntry {
    id: number;
    timestamp: Date;
    message: string;
    level: 'info' | 'warn' | 'error';
}

const MAX_LOG_ENTRIES = 300;

/**
 * Singleton store for debug log messages.
 * Accessible from anywhere without needing React context.
 */
class DebugLogStoreImpl {
    private _nextId = 1;

    @observable accessor entries: DebugLogEntry[] = [];

    @action log = (message: string, level: DebugLogEntry['level'] = 'info') => {
        this.entries.push({
            id: this._nextId++,
            timestamp: new Date(),
            message,
            level,
        });

        // Keep only the last N entries
        if (this.entries.length > MAX_LOG_ENTRIES) {
            this.entries = this.entries.slice(-MAX_LOG_ENTRIES);
        }
    };

    @action info = (message: string) => {
        this.log(message, 'info');
    };

    @action warn = (message: string) => {
        this.log(message, 'warn');
    };

    @action error = (message: string) => {
        this.log(message, 'error');
    };

    @action clear = () => {
        this.entries = [];
    };
}

/** Global singleton debug log store */
export const debugLog = new DebugLogStoreImpl();
